
import{createSlice} from'@reduxjs/toolkit';

const initialState={
  isFavoriteOpen:false,
  FavoriteItems:[]
};

const FavoriteSlice=createSlice({
  name:'favorite',
  initialState,
  reducers:{

    toggleFavorite(state,action){
      state.isFavoriteOpen=action.payload;
    },
    
    addWishlist(state,action){
      const newItemId=action.payload.id;
      const existingItem=state.FavoriteItems.find(item=>item.id===newItemId);
      if(existingItem){
        existingItem.quantity++;
      }else{
        state.FavoriteItems.push(action.payload);
      }
    },

    removeWishlist(state,action){
      state.FavoriteItems=state.FavoriteItems.filter(item=>item.id !== action.payload);
    },

  }
});

export const{addWishlist,toggleFavorite,removeWishlist}=FavoriteSlice.actions;
export default FavoriteSlice.reducer;
